export default function ProductsHero() {
  const scrollToProducts = () => {
    const productsSection = document.querySelector('section.py-20.bg-gray-50');
    if (productsSection) {
      productsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const scrollToInquiry = () => {
    const inquirySection = document.querySelector('section.py-20.bg-white');
    if (inquirySection) {
      inquirySection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="relative bg-gradient-to-br from-green-50 to-blue-50 py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
            Sustainable Products & Services
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-4xl mx-auto">
            From premium Black Soldier Fly larvae and organic fertilizers to our pure Ghanaian moringa powder superfood — discover our complete range of sustainable solutions for agriculture and everyday wellness.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <button 
              onClick={scrollToProducts}
              className="bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              Browse Products
            </button>
            <button 
              onClick={scrollToInquiry}
              className="border-2 border-green-600 text-green-600 hover:bg-green-600 hover:text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              Request Quote
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
